import { parseTemplate } from 'url-template';
import { formatApiDate } from '~/Api/DateTime';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import { ErrorResponse } from './ErrorResponse';
import { mapSkMaxPrice } from './mapSkMaxPrice';
import { SkMaxPrice } from './SkMaxPrice';
import { Update } from './Update';

export interface Result {
	readonly skMaxPrice: SkMaxPrice;
}

export function updateSkMaxPrice(client: ApiClient, userId: string, groupId: string, update: Update): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/sk-max-price');

	return client
		.fetch(url.expand({ userId, groupId }), {
			method: 'POST',
			body: JSON.stringify({
				reference: {
					packageSize: update.packageSize,
					historicProductDataViewDate:
						update.historicProductDataViewDate !== null ? formatApiDate(update.historicProductDataViewDate) : null,
					referenceBasketVersion: update.referenceBasketVersion,
					priceComparisonFxDate:
						update.priceComparisonFxDate !== null ? formatApiDate(update.priceComparisonFxDate) : null,
				},
				products: update.products.map((product) => ({
					id: product.id,
					priceTypeForCalculation: product.priceTypeForCalculation,
					packageSizeForCalculation: product.packageSizeForCalculation,
					packageSizeForSingleUnit: product.packageSizeForSingleUnit,
					selected: product.selected,
				})),
			}),
		})
		.then((response) => response.json())
		.then((response) => ({
			skMaxPrice: mapSkMaxPrice(response.skMaxPrice),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, ErrorResponse));
}
